export default __webpack_public_path__ + "static/media/T_65_mobile.e33c1bdc.jpg";